import rules from './fieldVisibilityRules';
import { reportBase } from './reportsBase';
import { reportTypes } from '../../utils/reports';

const TYPE = reportTypes.creativeExplore;

export default {
    type: TYPE,
    fields: [
        ...reportBase.fields,
        'creativeShowPreview',
        'discrepancyMetrics',
        'creativeMeasurementDimensions',
        'promotedContentDetailsDimensions',
        'technicalSpecsDimensions',
        'metadataDimensions',
        'attributionInsightsDimensions',
        'custom_dimensions',
        'trackerData',
        'networkData',
        'discrepancies',
        'videoMetrics',
        'cohortMetrics',
        'periods',
        'customEvents',
        'conversionEvents',
        'governanceDimensions',
        'creativesAIDimensions',
        'creativesAICustomDimensions',
    ],
    visibleRule: rules[TYPE],
    dataSelector: {
        ...reportBase.dataSelector,
        creativeMeasurementDimensions: 'creativeMeasurementDimensions',
        promotedContentDetailsDimensions: 'promotedContentDetailsDimensions',
        technicalSpecsDimensions: 'technicalSpecsDimensions',
        metadataDimensions: 'metadataDimensions',
        attributionInsightsDimensions: 'attributionInsightsDimensions',
        custom_dimensions: 'custom_dimensions',
        trackerData: 'trackerData',
        networkData: 'networkData',
        discrepancies: 'discrepancies',
        videoMetrics: 'videoMetrics',
        cohortMetrics: 'cohortMetrics',
        periods: 'periods',
        customEvents: 'customEvents',
        conversionEvents: 'conversionEvents',
        governanceDimensions: 'governanceDimensions',
        creativesAIDimensions: 'creativesAIDimensions',
        creativesAICustomDimensions: 'creativesAICustomDimensions',
        mode: 'mode',
        tableDataFormatted: 'reportData',
        chartDataFormatted: 'chartData',
        chart: 'chart',
        selectedSources: 'selectedSources',
        selectedApps: 'selectedApps',
        isAdvanceMode: 'isAdvanceMode',
        displayAlignment: 'displayAlignment',
    },
    isCreativeExplore: true,
};
